<script setup lang="ts">
import { PhCaretLeft, PhPlug, PhWarning } from "@phosphor-icons/vue";
import { OTPInput, REGEXP_ONLY_DIGITS } from "vue-input-otp";
</script>

<template>
  <section id="authView" class="auth-view" aria-label="登录">
    <header class="view-header auth-view-header">
      <button id="authBackButton" class="icon-button" type="button" aria-label="返回素材总览">
        <PhCaretLeft :size="18" weight="bold" aria-hidden="true" />
      </button>
      <div class="view-title-group">
        <h2 id="authViewTitle">邮箱登录</h2>
        <span id="authViewSubtitle">登录后使用在线服务</span>
      </div>
    </header>

    <div id="authRestoringPanel" class="auth-state auth-restoring" role="status" aria-live="polite">
      <span class="auth-spinner" aria-hidden="true"></span>
      <span>正在连接</span>
    </div>

    <form id="emailRequestForm" class="auth-state auth-form" novalidate hidden>
      <label class="auth-field" for="authEmailInput">
        <span>邮箱</span>
        <input
          id="authEmailInput"
          name="email"
          type="email"
          inputmode="email"
          autocomplete="email"
          placeholder="name@example.com"
          spellcheck="false"
          required
        />
      </label>
      <p id="emailRequestError" class="auth-message" data-tone="error" role="alert" hidden></p>
      <button id="requestEmailCodeButton" class="primary-button auth-submit" type="submit">
        <span class="button-progress" aria-hidden="true"></span>
        <span id="requestEmailCodeLabel">获取验证码</span>
      </button>
    </form>

    <form id="emailVerifyForm" class="auth-state auth-form" novalidate hidden>
      <label class="auth-field auth-code-field" for="authCodeInput">
        <span class="visually-hidden">验证码</span>
        <OTPInput
          v-slot="{ slots }"
          id="authCodeInput"
          name="code"
          container-class="auth-code-input"
          :maxlength="6"
          :pattern="REGEXP_ONLY_DIGITS"
          inputmode="numeric"
          autocomplete="one-time-code"
          aria-label="6 位验证码"
          aria-describedby="emailVerifyMessage"
          push-password-manager-strategy="none"
          required
        >
          <span
            v-for="(slot, index) in slots"
            :key="index"
            class="auth-code-slot"
            :class="{ 'is-active': slot.isActive }"
            aria-hidden="true"
          >
            <span v-if="slot.char !== null">{{ slot.char }}</span>
            <span v-else-if="slot.hasFakeCaret" class="auth-code-caret"></span>
          </span>
        </OTPInput>
      </label>
      <p id="emailVerifyMessage" class="auth-message" data-tone="error" role="alert" hidden></p>
      <button id="verifyEmailCodeButton" class="primary-button auth-submit" type="submit">
        <span class="button-progress" aria-hidden="true"></span>
        <span id="verifyEmailCodeLabel">登录</span>
      </button>
      <div class="auth-secondary-actions">
        <button id="resendEmailCodeButton" class="text-button" type="button">60 秒后可重发</button>
        <button id="changeEmailButton" class="text-button" type="button">更换邮箱</button>
      </div>
    </form>

    <section id="deviceLimitPanel" class="auth-state auth-blocked" aria-labelledby="deviceLimitTitle" hidden>
      <span class="auth-state-icon auth-state-icon--warning" aria-hidden="true">
        <PhWarning :size="22" weight="bold" />
      </span>
      <h2 id="deviceLimitTitle">设备已满</h2>
      <p id="deviceLimitMessage">请在已登录设备中移除一台后重试。</p>
      <button id="deviceLimitBackButton" class="secondary-button" type="button">返回邮箱</button>
    </section>

    <section id="authUnavailablePanel" class="auth-state auth-blocked" aria-labelledby="authUnavailableTitle" hidden>
      <span class="auth-state-icon" aria-hidden="true">
        <PhPlug :size="22" weight="bold" />
      </span>
      <h2 id="authUnavailableTitle">无法连接服务</h2>
      <p id="authUnavailableMessage">检查网络后重试。</p>
      <button id="retryAuthButton" class="primary-button auth-retry" type="button">
        <span class="button-progress" aria-hidden="true"></span>
        <span>重试</span>
      </button>
      <button id="useAnotherEmailButton" class="text-button auth-switch-account" type="button" hidden>使用其他邮箱</button>
    </section>
  </section>
</template>
